import React from 'react';
import {
  Grid,
  Typography,
  Box,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableBody,
  Paper,
  TableCell,
} from '@mui/material';
import { useApiGet } from '../../utils/httpClient';
import { getUserUpdateHistory } from '../../endpoints/usersTs';
import { TableVirtuoso } from 'react-virtuoso';
import dayjs from 'dayjs';
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      size="small"
      sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => (
    <TableHead {...props} ref={ref} />
  )),
  TableRow,
  TableBody: React.forwardRef((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

export default function UserHistory({ id }) {
  const { data: userHistory, isLoading } = useApiGet(
    ['userHistory', id],
    getUserUpdateHistory,
    {
      enabled: !!id,
    },
    { id }
  );
  if (isLoading) {
    return (
      <Grid container>
        <Grid item xs={12} padding>
          <Typography variant="h6">Loading...</Typography>
        </Grid>
      </Grid>
    );
  }
  if (!userHistory) {
    return (
      <Grid container>
        <Grid item xs={12} padding>
          <Typography variant="h6">History not found</Typography>
        </Grid>
      </Grid>
    );
  }
  const columns = [
    { dataKey: 'field_name', label: 'Field', width: 100 },
    { dataKey: 'old_value', label: 'Old Value', width: 150 },
    { dataKey: 'new_value', label: 'New Value', width: 150 },
    {
      dataKey: 'updated_at',
      label: 'Updated At',
      width: 150,
      fieldType: 'date',
    },
    { dataKey: 'updated_by', label: 'Updated By', width: 150 },
  ];

  const formatFieldValue = (value, fieldType) => {
    if (fieldType === 'date') {
      return dayjs.utc(value).local().format('YYYY-MM-DD h:mm a');
    }
    return value;
  };
  const fixedHeaderContent = () => {
    return (
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.dataKey}
            variant="head"
            align={column.dataKey === 'action' ? 'left' : 'right'}
            style={{ width: column.width }}
            sx={{
              backgroundColor: 'background.paper',
            }}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  const rowContent = (_index, row) => {
    return (
      <React.Fragment>
        {columns.map((column) => (
          <TableCell key={column.dataKey} align={'right'}>
            {formatFieldValue(row[column.dataKey], column.fieldType)}
          </TableCell>
        ))}
      </React.Fragment>
    );
  };

  const renderEmptyPlaceholder = (props) => {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columns.length}
            style={{ textAlign: 'center', padding: '20px' }}
          >
            No data available
          </td>
        </tr>
      </tbody>
    );
  };
  return (
    <Grid container>
      <Grid item xs={12} padding={3}>
        <Box sx={{ height: 500 }}>
          <TableVirtuoso
            data={userHistory}
            components={{
              ...VirtuosoTableComponents,
              EmptyPlaceholder: renderEmptyPlaceholder,
            }}
            fixedHeaderContent={fixedHeaderContent}
            itemContent={rowContent}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
